export default "/build/images/alshrm.png?63c78877e477e53372ef097e468ffd00";